<div class="row contenedor-detalle-siniestro mx-1 mt-2">
    <div class="col-lg-8 col-md-12 col-12 my-3" [ngClass]="{' borde-derecho' : !['xs', 'sm', 'md'].includes(screenSize)}">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo">COBERTURAS</small>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12 my-4 overflow-auto">
                <table mat-table multiTemplateDataRows [dataSource]="datosCoberturas"
                    class="table d-xl-table d-md-table table-responsive my-2">
                    <ng-container matColumnDef="ClaveCobertura" [sticky]="true">
                        <th mat-header-cell class="px-2" *matHeaderCellDef>No.</th>
                        <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.cve_coberturak}}</td>
                    </ng-container>
                    <ng-container matColumnDef="Descripcion">
                        <th mat-header-cell class="px-2" *matHeaderCellDef>Descripción</th>
                        <td mat-cell *matCellDef="let element" class="mx-1">{{element?.des_coberturak}}</td>
                    </ng-container>
                    <ng-container matColumnDef="Deducible">
                        <th mat-header-cell class="px-2" *matHeaderCellDef>Deducible</th>
                        <td mat-cell *matCellDef="let element" class="mx-1">{{element?.porc_deduc}}</td>
                    </ng-container>
                    <ng-container matColumnDef="SumaAsegurada">
                        <th mat-header-cell class="px-2" *matHeaderCellDef>Suma Asegurada</th>
                        <td mat-cell *matCellDef="let element" class="mx-1">{{element?.suma_aseg}}</td>
                    </ng-container>
                    <ng-container matColumnDef="EstatusSiniestro">
                        <th mat-header-cell class="px-2" *matHeaderCellDef>Estatus al Siniestro</th>
                        <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_status}}</td>
                    </ng-container>
                    <ng-container matColumnDef="Ver">
                        <th mat-header-cell class="px-2" *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element" class="mx-1">
                            <i class="far fa-file-alt" (click)="abrirModalDetalleCobertura(element)"></i>
                        </td>
                    </ng-container>

                    <!-- Sin resultados -->
                    <ng-container matColumnDef="noData">
                        <td mat-footer-cell *matFooterCellDef colspan="6">
                            <small>No se encontró ningún resultado</small>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="SelectRow(row, 'COBERTURA')"
                        [ngClass]="{'highlightTableColor': selectedCoberturaRowIndex == row.cve_coberturak }"> </tr>
                    <tr mat-footer-row *matFooterRowDef="['noData']"
                        [ngClass]="(datosCoberturas?.data?.length === 0) ? '':'ocultarPaginator'"></tr>
                </table>
                <mat-paginator [pageSizeOptions]="[5, 10, 20, 50,100]" showFirstLastButtons
                    aria-label="Select page of periodic elements">
                </mat-paginator>
            </div>
        </div>

    </div>
    <div class="col-lg-4 col-md-12 col-12 my-3">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo">VEHÍCULO</small>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12 col-12 d-flex align-items-center mt-2 mb-2">
                <div class="flex-grow-1 d-flex justify-content-between">
                    <small class="titulo" style="min-width: 120px;">Placas : </small>
                    <strong class="valorTextoWeight-500">{{siniestroCompleto?.placas}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 d-flex align-items-center mb-2">
                <div class="flex-grow-1 d-flex justify-content-between">
                    <small class="titulo"  style="min-width: 120px;">Serie Emisión : </small>
                    <strong class="valorTextoWeight-500">{{siniestroCompleto?.serie_emision}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 d-flex align-items-center mb-2">
                <div class="flex-grow-1 d-flex justify-content-between">
                    <small class="titulo"  style="min-width: 120px;">Motor : </small>
                    <strong class="valorTextoWeight-500">{{siniestroCompleto?.motor}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 d-flex align-items-center mb-2">
                <div class="flex-grow-1 d-flex justify-content-between">
                    <small class="titulo"  style="min-width: 120px;">Color : </small>
                    <strong class="valorTextoWeight-500">{{siniestroCompleto?.color}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 d-flex align-items-center mb-2">
                <div class="flex-grow-1 d-flex justify-content-between">
                    <small class="titulo"  style="min-width: 120px;">RFV : </small>
                    <strong class="valorTextoWeight-500">{{siniestroCompleto?.rfv}}</strong>
                </div>
            </div>
        </div>
    </div>
</div>